<ng-container>
	<ion-header translucent="true">
		<ion-toolbar>
			<ion-buttons slot="start">
				<ion-button (click)="dismiss()">Close</ion-button>
			</ion-buttons>
			<ion-title>
				{{ segment.value }}
			</ion-title>
		</ion-toolbar>
	</ion-header>
	<!--CONTENT-->
	<ion-content [scrollY]="segment.value !== 'Signature'" class="ion-padding">
		<ion-segment (ionChange)="prepareSignaturePad()" #segment value="Consent">
			<ion-segment-button value="Consent">
				<ion-label>Consent</ion-label>
			</ion-segment-button>
			<ion-segment-button [disabled]="!(hasConsented$ | async)" [value]="isInitials ? 'Initials' : 'Signature'">
				<ion-label>{{ isInitials ? 'Initials' : 'Signature' }}</ion-label>
			</ion-segment-button>
		</ion-segment>
		<!--CANCELLATION-->
		<div [hidden]="segment.value !== 'Cancellation'">
			CANCELLATION POLICY
		</div>
		<!--CONSENT-->
		<div [hidden]="segment.value !== 'Consent'">
			<div class="my-2 text-xs space-y-3">
				<!--DEFAULT MESSAGING-->
				<div>
					{{ defaultLanguage }}
				</div>
				<div class="mt-2 text-sm font-semibold" *ngIf="companyFacilityService.companyData$ | async as company">
					{{ company.companyName }} <span *ngIf="company.companyName && company.email">|</span>
					{{ company.email }}
				</div>
				<div>
					<form class="my-2" [formGroup]="consentForm">
						<!--CAN READ AND UNDERSTAND ENGLISH-->
						<ion-item [disabled]="hasConsented$ | async">
							<ion-label class="ion-padding">I can read and understand English</ion-label>
							<ion-checkbox slot="end" formControlName="canReadAndUnderstandConsent"></ion-checkbox>
						</ion-item>
						<!--CONSENT TO ELECTRONIC SIGNATURE-->
						<ion-item [disabled]="hasConsented$ | async">
							<ion-label class="ion-padding">I consent to electronic signature</ion-label>
							<ion-checkbox slot="end" formControlName="consentToElectronicSignature"></ion-checkbox>
						</ion-item>
						<!--BUTTONS-->
						<div class="flex justify-between space-x-2 my-4">
							<ion-button color="danger" [disabled]="hasConsented$ | async" (click)="dismiss()" class="flex-1">I Do Not Agree</ion-button>
							<ion-button color="success" [disabled]="consentForm.invalid" (click)="agreeToConsent()" class="flex-1">I Agree</ion-button>
						</div>
					</form>
				</div>
			</div>
		</div>

		<!--SIGNATURE-->
		<div [hidden]="segment.value !== (isInitials ? 'Initials' : 'Signature')" class="h-full">
			<!--CONTAINER-->
			<div #signatureContainer class="mt-2 h-2/3">
				<canvas #signaturePad [width]="signatureContainer.offsetWidth"
				        [height]="signatureContainer.offsetHeight" class="signature-pad"></canvas>
				<div class="text-center -my-32 border-t-4 border-black mx-2">
					<h1 class="text-2xl font-bold">{{ isInitials ? 'INITIALS' : 'SIGNATURE' }}</h1>
				</div>
			</div>
			<div class="flex justify-between mt-4">
				<ion-button color="danger" (click)="clear()" class="flex-1 mr-2">Clear</ion-button>
				<ion-button [disabled]="disableSaveSignature$ | async" color="success" (click)="save()" class="flex-1">Sign</ion-button>
			</div>
		</div>
	</ion-content>
</ng-container>